import React from "react";

import {
  Button,
  IconButton,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { Add as AddIcon } from "@mui/icons-material";
import StereoChalQuestionForm from "./StereoChalQuestionForm";

// ----------------------------------------------------------------------
export default function StereoChalQuestionEditBtn({
  editData,
  addLabel,
  handleCompleteQuestion,
}) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const getTitle = () => {
    try {
      if (editData && editData.id) {
        return `Modification`;
      } else {
        return addLabel;
      }
    } catch (error) {
      return "";
    }
  };

  const getIcon = () => {
    try {
      if (editData && editData.id) {
        return (
          <IconButton
            aria-label="details"
            size="small"
            onClick={handleClickOpen}
          >
            <EditIcon size="small" />
          </IconButton>
        );
      } else {
        return (
          <Button
            variant="outlined"
            color="warning"
            onClick={handleClickOpen}
            fullWidth
            sx={{ my: 3 }}
          >
            <AddIcon />
            {getTitle()}
          </Button>
        );
      }
    } catch (error) {
      return <></>;
    }
  };
  const onCompleteQuestion = (data) => {
    handleCompleteQuestion(data);
    handleClose();
  };
  return (
    <div>
      {getIcon()}
      <Dialog open={open} fullWidth maxWidth="lg">
        <DialogTitle> {getTitle()}</DialogTitle>
        <DialogContent>
          <StereoChalQuestionForm
            editData={editData}
            onCompleteQuestion={onCompleteQuestion}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Annuler</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
